import { render, staticRenderFns } from "./FileDropAreaComponent.vue?vue&type=template&id=06180f6a&scoped=true"
import script from "./FileDropAreaComponent.vue?vue&type=script&lang=js"
export * from "./FileDropAreaComponent.vue?vue&type=script&lang=js"
import style0 from "./FileDropAreaComponent.vue?vue&type=style&index=0&id=06180f6a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06180f6a",
  null
  
)

export default component.exports